// ErrorBoundary.tsx
import React, { ReactElement, useEffect } from 'react';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../appInsights';
import PageNotFound from '../layout/PageNotFound';

const ErrorBoundary = ({ children }: { children: ReactElement }) => {
    useEffect(() => {
        const handleGlobalError = (event: ErrorEvent) => {
            try {
                reactPlugin.trackException({
                    exception: event.error || new Error(event.message),
                    properties: {
                        url: window.location.href,
                        userAgent: navigator.userAgent,
                    },
                });
            } catch (error) {
                console.error('Failed to track exception', error);
            }
        };

        const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
            try {
                reactPlugin.trackException({
                    exception: new Error(event.reason as string),
                });
            } catch (error) {
                console.error('Failed to track exception', error);
            }
        };

        window.addEventListener('error', handleGlobalError, true);
        window.addEventListener('unhandledrejection', handleUnhandledRejection);

        return () => {
            window.removeEventListener('error', handleGlobalError);
            window.removeEventListener(
                'unhandledrejection',
                handleUnhandledRejection
            );
        };
    }, []);

    return (
        <AppInsightsErrorBoundary
            appInsights={reactPlugin}
            onError={PageNotFound}
        >
            {children}
        </AppInsightsErrorBoundary>
    );
};

export default ErrorBoundary;
